//
//
//
//
//
//
//
//
//
//
//
//

import QqMap from '@/components/views/map'
export default {
    components: {
        QqMap
    },
    data () {
        return {
            latitude: '',
            longitude: '',
            name: '',
            address: '',
            markers: []
        }
    },
    mounted () {
        const {
            latitude,
            longitude,
            name,
            address
        } = this.$route.query
        this.latitude = Number(latitude)
        this.longitude = Number(longitude)
        this.name = name
        this.address = address
        this.markers = [
            {
                title: name,
                latitude: this.latitude,
                longitude: this.longitude,
                iconPath: 'https://cdn.vip-wifi.com/fangchan/img/building/around_facilities/house.png',
                zIndex: 2,
                width: 22,
                height: 37,
                callout: {
                    content: name,
                    color: '#ffffff',
                    fontSize: '14px',
                    bgColor: '#00B800',
                    borderRadius: '22.5px',
                    padding: '8px',
                    textAlign: 'center',
                    zIndex: 10
                }
            }
        ]
        console.log(123456, this.markers)
    }
}
